import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-choose-plan',
  templateUrl: './payment-choose-plan.component.html',
  styleUrls: ['./payment-choose-plan.component.scss']
})
export class PaymentChoosePlanComponent implements OnInit {
  sectionTitle = "Choose Your Plan"
  cancelSubscription = "Cancel any time"
  
  PaymentChoosePlan = [
    {
      title: '£B',
      text: 'Per Quarter',
      pourcentage: 'Save y%'
    },
    {
      title: '£A',
      text: 'Per Year',
      pourcentage: 'Save y%'
    },
    {
      title: '£C',
      text: 'Per Month'
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
